exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#iconTextGroup[data-v-5fc9626e]{margin-left:auto;margin-right:auto}", ""]);

// exports
